import { render } from "./masterProductTableLite.vue?vue&type=template&id=3b3b4cf9&scoped=true"
import script from "./masterProductTableLite.vue?vue&type=script&lang=js"
export * from "./masterProductTableLite.vue?vue&type=script&lang=js"

import "./masterProductTableLite.vue?vue&type=style&index=0&id=3b3b4cf9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3b4cf9"]])

export default __exports__